var exports = {
  "vK": "x31de4314--fb40a8--banner",
  "SA": "x31de4314--fb40a8--fixed-width",
  "xA": "x31de4314--fb40a8--left-border",
  "_f": "x31de4314--fb40a8--right-border",
};

module.exports = exports;
